<sb-card>
  <div card-body>

    <form [formGroup]="formTargeting" class="wizard__forms w-100">
      <div class="row">
        <div class="col-6">
          <div class="form-group validateMe">
            <label for="Name" class="form-label">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
            <input type="text" id="Name" class="form-control" formControlName="Name"
                   sbAutofocus required>
            <div *ngIf="Name.touched && Name.errors?.required" class="alert alert-danger">
              {{'lang.globals.nameWarning' | translate}}</div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group validateMe">
            <label for="Description" class="form-label">{{'lang.globals.description' | translate}}</label>
            <input type="text" id="Description" class="form-control" formControlName="Description">
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group d-grid">
            <label class="form-label" for="Company">{{'lang.globals.company' | translate}}<span class="red">*</span></label>
            <button [disabled]="targeting?.id" (click)="selectCompany()" type="button" id="Company"
                    class="btn btn-secondary  text-center">
              <sb-icon class="mr-1" icon="company"></sb-icon>
              {{targeting?.customer ? targeting?.customer?.name : translate.instant('lang.globals.default')}}
            </button>
          </div>
        </div>

        <div class="col-6">
          <div class="form-group validateMe">
            <label class="form-label" for="TargetingTarget">{{'lang.targeting.target' | translate}}<span class="red">*</span></label>
            <select id="TargetingTarget" class="form-select" formControlName="Target">
              <option *ngFor="let target of targetingTypes" [value]="target">
                {{'lang.targeting.target.' + target | translate}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group validateMe">
            <label class="form-label" for="TargetingRelation">{{'lang.targeting.relation' | translate}}<span class="red">*</span></label>
            <select id="TargetingRelation" class="form-select" formControlName="Relation">
              <option *ngFor="let relation of timingRelations" [value]="relation">
                {{'lang.targetingAndBudget.timingRelations.' + relation | translate}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group validateMe">
            <label class="form-label" for="TargetingAmount">{{'lang.targeting.amount' | translate}}<span class="red">*</span></label>
            <div class="input-group">
              <input type="number" id="TargetingAmount" class="form-control text-end"
                     formControlName="Amount">
              <div class="input-group-append">
                <ng-container *ngIf="TargetingTarget?.value">
                  <ng-container
                    *ngIf="TargetingTarget?.value?.includes('PlaybackTime'); else timingRelationDefault;">
                    <span class="input-group-text h-100">s</span>
                  </ng-container>
                  <ng-template #timingRelationDefault>
                                  <span
                                    class="input-group-text h-100">{{'lang.targeting.target.' + TargetingTarget?.value | translate}}</span>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="d-flex justify-content-between mt-4">
      <button (click)="editTargeting.emit(null)" class="btn btn-default">
        {{'lang.globals.cancel'|translate}}
      </button>
      <button (click)="editTargeting.emit(targeting)" [disabled]="formTargeting.invalid || !targeting?.customer" class="btn btn-primary">
        {{targeting.id?('lang.globals.save' |translate): ('lang.globals.create' |translate)}}</button>
    </div>
  </div>
</sb-card>
